module.exports = __webpack_public_path__ + "images/182_2048.jpg";